import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { riskInspect } from '../../../constants/routes';

function authHeader() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

function RiskHome() {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [propertyId, setPropertyId] = useState('');
  const [templateId, setTemplateId] = useState('');
  const [loading, setLoading] = useState(true);
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setError('');
      setLoading(true);
      try {
        const [pRes, tRes] = await Promise.all([
          axios.get('/api/risk/picker/properties', { headers: authHeader() }),
          axios.get('/api/risk/templates', { headers: authHeader() }),
        ]);
        if (cancelled) return;
        setProperties(pRes.data);
        setTemplates(tRes.data);
        if (tRes.data.length === 1) setTemplateId(String(tRes.data[0].id));
        else {
          const risk = tRes.data.find((t) => t.slug === 'risk-checklist');
          if (risk) setTemplateId(String(risk.id));
        }
        if (pRes.data.length === 1) setPropertyId(String(pRes.data[0].id));
      } catch (e) {
        if (!cancelled) setError(e.response?.data?.error || e.message || 'Failed to load');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const startInspection = async () => {
    if (!propertyId || !templateId) {
      setError('Select a property and checklist.');
      return;
    }
    setStarting(true);
    setError('');
    try {
      const res = await axios.post(
        '/api/risk/inspections',
        { propertyId: Number(propertyId), templateId: Number(templateId) },
        { headers: authHeader() }
      );
      navigate(riskInspect(res.data.id));
    } catch (e) {
      setError(e.response?.data?.error || e.message || 'Could not start inspection');
    } finally {
      setStarting(false);
    }
  };

  if (loading) {
    return (
      <div className="app-loading text-muted" role="status">
        <span className="spinner-border spinner-border-sm" aria-hidden="true" />
        <span>Loading…</span>
      </div>
    );
  }

  return (
    <div className="card app-card" style={{ maxWidth: 520 }}>
      <div className="card-body">
        <h2 className="h5 card-title">Start inspection</h2>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <div className="mb-3">
          <label className="form-label">Property</label>
          <select
            className="form-select"
            value={propertyId}
            onChange={(e) => setPropertyId(e.target.value)}
          >
            <option value="">Select property…</option>
            {properties.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
                {p.property_code ? ` (${p.property_code})` : ''}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Checklist</label>
          <select
            className="form-select"
            value={templateId}
            onChange={(e) => setTemplateId(e.target.value)}
          >
            <option value="">Select checklist…</option>
            {templates.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>
        <button
          type="button"
          className="btn btn-primary"
          disabled={starting || !propertyId || !templateId}
          onClick={startInspection}
        >
          {starting ? 'Starting…' : 'Start inspection'}
        </button>
      </div>
    </div>
  );
}

export default RiskHome;
